const headingArray: string[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h6'];

export const getSubheadingType = (
  headingSeoType: keyof HTMLElementTagNameMap,
) => {
  const seoIndex = headingArray.indexOf(headingSeoType);

  return headingArray[seoIndex + 1] as keyof HTMLElementTagNameMap;
};
